(() => {
  'use strict';
  if (customElements.get('lunzoa-purchase-dock')) return;

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-lz-details-link]');
    if (!link) return;
    const details = document.getElementById(link.getAttribute('href').slice(1));
    if (!details) return;
    event.preventDefault();
    details.open = true;
    const summary = details.querySelector('summary');
    summary.setAttribute('aria-expanded', 'true');
    summary.focus({ preventScroll: true });
    details.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  class LunzoaPurchaseDock extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.root = document.getElementById(this.dataset.productRoot);
      if (!this.root) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.querySelector('button').addEventListener('click', () => this.returnToOptions(), { signal });
      window.addEventListener('scroll', this.schedule, { signal, passive: true });
      window.addEventListener('resize', this.schedule, { signal, passive: true });
      document.addEventListener('focusin', this.schedule, { signal });
      document.addEventListener('focusout', this.schedule, { signal });
      document.addEventListener('toggle', this.schedule, { signal, capture: true });
      this.mobile.addEventListener('change', this.schedule, { signal });
      this.bodyObserver = new MutationObserver(this.schedule);
      this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.sizeObserver = new ResizeObserver(this.schedule);
      this.sizeObserver.observe(this.root);
      this.root.classList.add('lz-product-enhanced');
      this.schedule();
    }

    update() {
      const controls = this.root.querySelector('product-form .product-form__buttons');
      const header = document.querySelector('.section-header');
      const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
      const controlsRect = controls?.getBoundingClientRect();
      const overlay = document.querySelector('cart-drawer.active, header-drawer details[open], modal-dialog[open], product-modal[open], dialog[open], details-modal details[open]');
      const footer = document.querySelector('footer');
      const editing = document.activeElement?.matches('textarea, select, input:not([type="radio"]):not([type="checkbox"]), [contenteditable="true"]');
      this.hidden = !this.mobile.matches || !controlsRect || controlsRect.height === 0 ||
        controlsRect.bottom > headerBottom || this.root.getBoundingClientRect().bottom <= headerBottom ||
        Boolean(footer && footer.getBoundingClientRect().top < window.innerHeight) ||
        Boolean(overlay) || editing || [...document.body.classList].some(name => name.startsWith('overflow-hidden'));
    }

    returnToOptions() {
      const picker = this.root.querySelector('variant-selects');
      const form = this.root.querySelector('product-form');
      const target = picker || form;
      if (!target) return;
      const focusTarget = picker?.querySelector('select:not(:disabled)') ||
        picker?.querySelector('input:checked:not(:disabled)') || picker?.querySelector('input:not(:disabled)') ||
        form?.querySelector('button[type="submit"]:not(:disabled)') || target;
      const headerBottom = Math.max(0, document.querySelector('.section-header')?.getBoundingClientRect().bottom || 0);
      const top = window.scrollY + target.getBoundingClientRect().top - headerBottom - 24;
      // Moving focus immediately avoids losing it when the fixed shortcut hides.
      if (focusTarget === target && !target.hasAttribute('tabindex')) target.tabIndex = -1;
      focusTarget.focus({ preventScroll: true });
      window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      this.schedule();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.bodyObserver?.disconnect();
      this.sizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.root?.classList.remove('lz-product-enhanced');
      this.controller = null;
      this.frame = null;
    }
  }

  if (!customElements.get('lunzoa-purchase-dock')) customElements.define('lunzoa-purchase-dock', LunzoaPurchaseDock);
})();
